import { GoogleIcon } from '@wiggot/web-components'

interface IProps {
  icon: string
  label: string | number
}

export const IconDetail = ({ icon, label }: IProps) => {
  return (
    <div className="flex items-center gap-1">
      <span className="text-xs mr-1">{label}</span>
      <GoogleIcon name={icon} className="text-sm text-surface-gray-20" />
    </div>
  )
}
